<template>
    <DCard
        padding
    >
        <Form
            :providerbox-settings="providerboxSettings"
            :errors="errors"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Settings/ProviderboxSettings/Form'

export default {
    name: 'ProviderboxSettingsCreate',
    components: {
        Form
    },
    props: {
        providerboxSettings: {
            type: Object,
            default () {
                return {}
            }
        },
        errors: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    methods: {
        submitData (form) {
            form.post(this.$route('settings.providerbox-settings.store'))
        }
    }
}
</script>
